module.exports = __webpack_public_path__ + "img/logo-avatar-icon.fc4c6412.svg";